( function () {
	'use strict';

	/* @ngInject */
	/* eslint-disable max-params */
	function VideoSearchCtrl ( $scope, edivateLibraryService, ppdFactory, PPD_MESSAGES, Session, $q, _ ) {
		var self = this;

		self.results         = [];
		self.credentials     = Session.getCredentials();
		self.start           = 0;
		self.rows            = 24;
		self.emptySearchText = true;
		self.loading         = false;
		self.errorMessage    = false;
		self.isReq           = false;
		self.noResults       = false;
		self.ppdMessages     = PPD_MESSAGES;
		self.isDisabled      = ppdFactory.isViewDisabled();

		function starMatch ( str ) {
			return !( str || '' ).match( /^[A-Za-z0-9]$/ );
		}

		function reduceSearchText ( prev, curr ) {
			prev += curr;

			if ( starMatch( prev[ 0 ] ) ) {
				return curr;
			}

			return prev;
		}

		function updateProps ( data ) {
			var attachedData = ppdFactory.getAttachedPDs();

			return ppdFactory.attachProps( attachedData, data );
		}

		function attachProps ( data ) {
			data.name        = data.contentName;
			data.ContentName = data.contentName;
			data.ContentId   = data.contentId;
			data.id          = data.contentId;
			data.type        = 1;

			return data;
		}

		function getResults ( data ) {
			self.showLoadContents = true;
			self.errorMessage     = false;
			self.isReq            = false;

			if ( !data.length  ) {
				self.noResults = true;
				self.showLoadContents = false;
				return;
			}

			var collection = JSON.parse( angular.toJson( data ) );

			collection = collection.map( attachProps );
			collection = updateProps( collection );

			self.results.push.apply( self.results, collection );
		}

		function returnPromises ( promise ) {
			return $q.all( promise.map( function ( item ) {
				return item.$promise;
			} ) ).then( function ( res ) {
				return res;
			} );
		}

		function errorCallback () {
			self.errorMessage     = true;
			self.showLoadContents = false;
		}

		function getLibraries () {
			edivateLibraryService.getLibrary(
				self.searchText,
				self.start,
				self.rows,
				'video'
			)
			.then( returnPromises )
			.then( getResults )
			.catch( errorCallback )
			.finally( function () {
				self.loading = false;
			} );
		}

		function resetSearch () {
			self.emptySearchText  = true;
			self.results          = [ ];
			self.loading          = false;
			self.showLoadContents = false;
			self.noResults        = false;
		}

		function searchVideos ( isTicked ) {
			self.errorMessage    = false;
			self.emptySearchText = false;
			self.isReq           = true;

			if ( isTicked ) {
				self.start += self.rows;
			} else {
				self.start = 0;
				self.results = [];
			}

			if ( !self.searchText || ( self.searchText && starMatch( self.searchText[ 0 ] ) ) ) {
				resetSearch();
				return;
			}

			self.loading = true;
			getLibraries();
		}

		function isEnter () {
			if ( self.isReq ) {
				return;
			}

			self.results = [];

			searchVideos();
		}

		function onInputChange ( ev ) {
			self.searchText = ( ev.currentTarget.value || '' )
				.split( '' )
					.reduce( reduceSearchText, '' )
						.trim();

			if ( !self.searchText ) {
				resetSearch();
				$scope.$apply();
			}

			if ( !self.isReq && self.searchText ) {
				searchVideos();
			}
		}

		function onKeyup ( ev ) {
			var notAllowedKeys = [ 9, 91, 18, 13 ];

			if ( notAllowedKeys.indexOf( ev.which ) === -1 ) {
				onInputChange( ev );
			}
		}

		self.isEnter       = isEnter;
		self.onKeyup       = _.debounce( onKeyup, 1000 );
		self.keyup         = onKeyup;
		self.onInputChange = _.debounce( onInputChange, 1000 );
		self.searchVideos  = searchVideos;
	}

	angular
		.module( 'app.components' )
		.controller( 'VideoSearchCtrl', VideoSearchCtrl );

	VideoSearchCtrl.$inject = [ '$scope', 'edivateLibraryService', 'ppdFactory', 'PPD_MESSAGES', 'Session', '$q', '_' ];
} )( );
